import en from './en.json';

export const APPLICANT_FACING = 'applicant-facing' as const;
export const BACKEND_ONLY = 'backend-only' as const;

export type Audience = typeof APPLICANT_FACING | typeof BACKEND_ONLY;

// Compile-time assertion: errors if any top-level key in en.json is missing an audience tag.
// Update TOP_LEVEL_AUDIENCES whenever adding a new top-level key to en.json.
type _AllTopLevelKeysMustHaveAudience = Record<keyof typeof en, Audience>;

export const TOP_LEVEL_AUDIENCES: _AllTopLevelKeysMustHaveAudience = {
  send_message: BACKEND_ONLY,
  copied_to_clipboard: BACKEND_ONLY,
  english: BACKEND_ONLY,
  spanish: BACKEND_ONLY,
  privacy_policy: APPLICANT_FACING,
  terms_and_conditions: APPLICANT_FACING,
  redirecting: APPLICANT_FACING,
  not_found: APPLICANT_FACING,
  applicant_not_found: BACKEND_ONLY,
  something_went_wrong: APPLICANT_FACING,
  this_site_does_not_exist: APPLICANT_FACING,
  click_here: APPLICANT_FACING,
  tap_to_reload: APPLICANT_FACING,
  online: APPLICANT_FACING,
  survey_version: BACKEND_ONLY,
  arcgis_attachment_viewer: BACKEND_ONLY,
  api: APPLICANT_FACING,
  liveness: APPLICANT_FACING,
  selfie: APPLICANT_FACING,
  application_stage: BACKEND_ONLY,
  login: BACKEND_ONLY,
  mfa_link: APPLICANT_FACING,
  ai_coach: APPLICANT_FACING,
  applicant: APPLICANT_FACING,
  auth: APPLICANT_FACING,
  banking: APPLICANT_FACING,
  batches: BACKEND_ONLY,
  campaigns: BACKEND_ONLY,
  dashboard: BACKEND_ONLY,
  applicant_lookup: BACKEND_ONLY,
  menu: APPLICANT_FACING,
  payments: APPLICANT_FACING,
  queries: BACKEND_ONLY,
  questions: APPLICANT_FACING,
  reports: BACKEND_ONLY,
  admin: APPLICANT_FACING,
  admin_panel: BACKEND_ONLY,
  card: APPLICANT_FACING,
  device: APPLICANT_FACING,
  stats: BACKEND_ONLY,
  apply: APPLICANT_FACING,
  submission: APPLICANT_FACING,
  subsurvey: APPLICANT_FACING,
  ahh: APPLICANT_FACING,
  language: APPLICANT_FACING,
  months: APPLICANT_FACING,
  date: APPLICANT_FACING,
  unauthorized: APPLICANT_FACING,
  offline: APPLICANT_FACING,
  app_identities: BACKEND_ONLY,
  support: BACKEND_ONLY,
  likert: APPLICANT_FACING,
  program_admin: BACKEND_ONLY,
  component_library: APPLICANT_FACING,
  review: BACKEND_ONLY,
  user: BACKEND_ONLY,
  permissions: BACKEND_ONLY,
  organization: BACKEND_ONLY,
};
